import React from 'react'
import { Link } from 'react-router-dom';
import {arrow} from '../assets/icons'

const InfoBox=({text,link,btnText})=> (
    <div className='info-box'>
        <p className='font-medium sm:text-l text-center'>{text}</p>
        <Link to={link} target="_blank" rel="noopener noreferrer" className='neo-brutalism-white neo-btn'>
            {btnText}
            <img src={arrow} className='w-4 h-4 object-contain'/>
        </Link>
    </div>
)

const renderContent={
    1:(
        <h1 className='sm:text-xl sm:leading-snug text-center neo-brutalism-blue py-4 px-8 text-white mx-5'>
            Hello!, This is <span className='font-semibold'>Sairam Murugavel</span>
            <br/>
            Let me give you a house-tour of my portfolio
        </h1>
    ),
    2:(
        <InfoBox
            text="I am a 4th year CSE student passionate about Competitive Programming and Development..."
            link="/about"
            btnText="About me"
        />
    ),
    3:(
        <InfoBox
            text="I usually spend my free time learning something new and try to cook stuff out of it real time"
            link="/skills"
            btnText="Skills"
        />
    ),
    4:(
        <InfoBox
            text="Here are a selection of projects that have been part of my ongoing endeavors"
            link="/projects"
            btnText="Projects"
        />
    ),
    5:(
        <InfoBox
            text="I have consistently deployed my skills in highly competitive environments, yielding tangible results."
            link="/achievements"
            btnText="Achievements"
        />
    ),
    6:(
        <InfoBox
            text="I have gained valuable experience and have contributed to meaningful projects"
            link="/experience"
            btnText="Experience"
        />
    ),
    7:(
        <InfoBox
            text="You can check out my works and profiles at"
            link="/socials"
            btnText="Socials"
        />
    ),
    8:(
        <InfoBox
            text="If you are interested in my work or if you need any help, you can contact me"
            link="/contact"
            btnText="Contact Me"
        />
    ),
    
}



const HomeInfo = ({currentStage}) => {
  return renderContent[currentStage] || null;
}

export default HomeInfo